module.exports = __webpack_public_path__ + "static/media/loader.ca8df1d7.svg";